import $ from 'jquery';
import { setCookie, getCookie } from './switch-view'

const $segment_selector = $('.segment-selector');
const $segments = $('.segment');
const $load_more = $('.load-more');

segmentIsPart( getCookie( 'segment' ) ?? 'product' );

$segment_selector.on('click', (event, element) => {
	$segment_selector.removeClass('segment-selector--products');
	$segment_selector.removeClass('segment-selector--parts');

	$segments.each((index, element) => {
		$(element).hide();
		if ($(event.target).data('segment-trigger') === $(element).data('segment')) {
			$segment_selector.addClass('segment-selector--' + $(element).data('segment'));
			$(element).show();
			setCookie('segment', $(element).data('segment'), 1);
		}
	});

	segmentIsPart( getCookie( 'segment' ) );
});

function segmentIsPart( segment ) {
	if ( segment === 'parts' ) {
		$load_more.hide();
	} else {
		$load_more.show();
	}
}